import { Input, Select, Skeleton, Tooltip } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { IconCreditCard } from '@tabler/icons-react';
import { defaultIconStyle } from '../../theme/styling/iconStyling';
import { useTillOptions } from '../../util/api/commonQueries';
import type { SelectableBranchDto } from '../../util/types/SelectableBranchDto';

type TillSelectorProps<T> = {
	form: UseFormReturnType<T, (values: T) => T>;
	property: string;
	branchOptions: SelectableBranchDto | undefined;
	branchId: string;
};

export function FormTillSelector<T>({
	branchId,
	property,
	branchOptions,
	form,
}: TillSelectorProps<T>) {
	const { tillsQuery, filteredTills, tillsPlaceholder } = useTillOptions(
		branchId,
		branchOptions,
	);

	return (
		<>
			<Tooltip label={tillsPlaceholder}>
				{!tillsQuery.isLoading ? (
					<Select
						label={'Till'}
						placeholder={tillsPlaceholder}
						data={filteredTills ?? []}
						clearable
						comboboxProps={{
							transitionProps: { transition: 'pop', duration: 200 },
						}}
						key={form.key(property)}
						{...form.getInputProps(property)}
						data-cy={`${property}-input`}
						leftSection={<IconCreditCard {...defaultIconStyle} />}
					/>
				) : (
					<Input.Wrapper label={'Till'}>
						<Skeleton height={8} mt={6} width="100%" radius={'xl'} h={25} />
					</Input.Wrapper>
				)}
			</Tooltip>
		</>
	);
}
